<template>
  <div>
    Demo1 对象数组数据绑定checkbox 对象 绑定对象好像会导致选中的对象不更新视图
    <br>
    只有点2下全选按钮才会显示正确视图，但是数据其实是对的
    <div>
      <v-btn @click="handleSelectAll">
        全选/取消全选
      </v-btn>
      <hr>
      <v-checkbox
        v-for="authObj in authList"
        :key="authObj.id"
        v-model="selected"
        :value="authObj"
        class="mr-4"
        style="display: inline-flex;width: calc(22%);"
        @click="() => {}"
      >
        <template #label>
          {{ authObj.name }}
        </template>
      </v-checkbox>
      <hr>
      选择的数据长度: {{ selected.length }}
      <hr>
      selected: {{ selected }}
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      selected: [
      ],
      authList: [
        {
          id: 1,
          name: '权限1',
          code: '1'
        },
        {
          id: 2,
          name: '权限2',
          code: '2'
        },
        {
          id: 3,
          name: '权限3',
          code: '3'
        },
      ]
    };
  },
  mounted() {
    // ! BUG: 初始化无法更新视图 ？？
    // 循环10个 { id: index, name: '权限' + index, code: index }
    this.selected = Array.from({ length: 10 }, (v, i) => ({ id: i + 1, name: `权限${i + 1}`, code: i + 1 }));
  },
  methods: {
    handleSelectAll() {
      const selList = [...this.selected];
      // 如果没有选中，就全选
      if (this.authList.every(item => !this.selected.includes(item))) {
        this.selected = selList.concat(this.authList);
        console.log('全选', this.selected);
      } else {
        // 如果有选中，就取消选中
        const idlist = this.authList.map(item => item.id);
        this.selected = selList.filter(item => !idlist.includes(item.id));
        console.log('取消全选', this.selected);
      }
    },
  },
};
</script>

<style>

</style>
